import { render, staticRenderFns } from "./ReferenceForm.vue?vue&type=template&id=2d2ae5ae&scoped=true&"
import script from "./ReferenceForm.vue?vue&type=script&lang=js&"
export * from "./ReferenceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2ae5ae",
  null
  
)

export default component.exports